export default __webpack_public_path__ + "static/media/sora_magic_lantern.07af1b96.webp";